import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "inputArea", "input", "form"]

  showInput() {
    this.addButtonTarget.style.display = "none"
    this.inputAreaTarget.style.display = "block"
    this.inputTarget.focus()
  }

  hideInput() {
    this.inputTarget.value = ""
    this.inputAreaTarget.style.display = "none"
    this.addButtonTarget.style.display = "block"
  }

  submit(event) {
    event.preventDefault()
    if (this.inputTarget.value.trim() !== "") {
      this.formTarget.requestSubmit()
    }
  }

  afterSubmit(event) {
    if (event.detail.success) {
      this.hideInput()
    }
  }
}
